module.exports = __webpack_public_path__ + "img/vodacom-rugby-background-mobile.3ae2ec15.png";